import Thumbnails from "./Thumbnails/index";
import Cards from "./Cards/index";
import Slideshow from "./SlideShow";

export default {
  Thumbnails,
  Cards,
  Slideshow
};
